import { render, staticRenderFns } from "./LvDropdownSingleCategorySelect.vue?vue&type=template&id=b66d124e"
import script from "./LvDropdownSingleCategorySelect.vue?vue&type=script&lang=js"
export * from "./LvDropdownSingleCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports